import { storeToRefs } from 'pinia';
import { useAuthorityStore } from '@/stores/authority';
import { heartbeat } from '@/apis/modules/base/home';

const HEARTBEAT_INTERVAL = 60 * 1000;

/**
 * 心跳：登录后每分钟调用一次 /common/heartbeat，登出/未登录时自动停止
 * 需在 App.vue 顶层调用一次，覆盖 web 端与移动端
 */
export const useHeartbeat = () => {
  const authorityStore = useAuthorityStore();
  const { isLogin } = storeToRefs(authorityStore);

  let timer: ReturnType<typeof setInterval> | null = null;

  const beat = () => {
    heartbeat().catch(() => {
      // 心跳失败不弹错，等下个周期重试
    });
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const start = () => {
    if (timer) return;
    beat();
    timer = setInterval(beat, HEARTBEAT_INTERVAL);
  };

  watch(
    isLogin,
    (loggedIn) => {
      if (loggedIn) start();
      else stop();
    },
    { immediate: true },
  );

  onBeforeUnmount(stop);
};

